<!-- Responsive layout with proper mobile spacing -->
<div
  class="flex w-full flex-col bg-secondary-background px-6 py-12 lg:flex-row lg:items-center lg:justify-between lg:px-32 lg:py-20"
>
  <!-- Title section - Full width on mobile, fixed width on desktop -->
  <div class="mb-8 flex flex-col items-start gap-3 lg:mb-0 lg:w-[735px]">
    <h2
      class="text-2xl leading-tight text-neutral-800 lg:text-5xl lg:leading-tight"
    >
      {{ titleKey() ?? 'components.notificationsFooter.title' | translate }}
    </h2>
  </div>

  <!-- Form section - Full width on mobile, fixed width on desktop -->
  <div
    class="flex w-full flex-col items-start justify-start gap-6 lg:w-[583px]"
  >
    <p
      class="self-stretch text-base leading-normal font-normal text-neutral-800 lg:text-lg lg:leading-relaxed"
    >
      {{
        descriptionKey() ?? 'components.notificationsFooter.description'
          | translate
      }}
    </p>

    <div
      class="flex w-full flex-col items-start justify-start gap-4 self-stretch pt-4"
    >
      <form
        class="flex w-full flex-col items-start justify-start gap-5 self-stretch lg:flex-row"
        [formGroup]="form"
      >
        <div
          class="flex h-12 w-full items-center justify-start gap-2 rounded-full border border-black bg-white py-3 pr-4 pl-6 lg:grow"
          [class.opacity-50]="disabled()"
        >
          <input
            class="w-full bg-transparent text-base leading-normal font-normal text-neutral-500 outline-none placeholder:text-neutral-500"
            type="email"
            formControlName="email"
            placeholder="{{
              emailPlaceholderKey() ?? 'common.fieldPlaceholder.email'
                | translate
            }}"
            required
          />
        </div>

        <button
          class="flex h-12 w-full items-center justify-center gap-2 rounded-full border border-orange-500 bg-orange-500 px-6 py-3 text-white disabled:cursor-not-allowed disabled:opacity-50 lg:w-auto"
          [disabled]="form.invalid || disabled()"
          type="button"
        >
          <span class="text-base leading-normal font-normal">
            {{
              buttonTextKey() ?? 'components.notificationsFooter.subscribe'
                | translate
            }}
          </span>
        </button>
      </form>

      <!-- Error messages -->
      @if (
        form.get('email')?.invalid && form.get('email')?.touched && !disabled()
      ) {
        <div class="self-stretch text-sm text-error-text">
          @if (form.get('email')?.errors?.['required']) {
            <span>
              {{
                emailRequiredKey() ?? 'pages.contact.form.emailRequired'
                  | translate
              }}
            </span>
          }
          @if (form.get('email')?.errors?.['email']) {
            <span>
              {{
                emailInvalidKey() ?? 'pages.contact.form.emailInvalid'
                  | translate
              }}
            </span>
          }
        </div>
      }

      <!-- Privacy text -->
      <div class="flex flex-wrap items-start justify-start gap-1 self-stretch">
        <p class="text-sm leading-tight font-normal text-neutral-800">
          {{ privacyAgreementKey() ?? 'common.privacyAgreement' | translate }}
        </p>
        <a
          class="text-sm leading-tight text-neutral-800 underline"
          [routerLink]="privacyTermsLink()"
        >
          {{ privacyTermsKey() ?? 'common.privacyTerms' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
